// components/Loader.js
import React from 'react';
import './Loader.css';
import { useLoader } from './LoaderContext';
import loadingGif from '../assets/images/loader.gif';

const Loader = () => {
  const { isLoading } = useLoader();

  return (
    <div className={`loader ${isLoading ? 'visible' : 'hidden'}`}>
      <img
        width={200}
        src={loadingGif}
        alt="Loading..."
        className="loader-gif"
      />
    </div>
  );
};

export default Loader;
